import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { Link } from '@/domain/types/collections';
import { useAdminLogger } from '@/domain/use-cases/admin-logger';
import useGetDocument from '@/domain/use-cases/get-document';
import AlertMessage from '@/presentation/components/alert-message';
import CommentsDetailDocument from '@/presentation/components/detail-document/comments';
import HeaderDetailDocument from '@/presentation/components/detail-document/header';
import StatsDetailDocument from '@/presentation/components/detail-document/stats';
import FormAddDocument from '@/presentation/components/form-add-document';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const LinkDetailsPage = () => {
  const [isAlertMessageOpen, setIsAlertMessageOpen] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const { logUpdate, logDelete } = useAdminLogger();

  const {
    data,
    error,
    isLoading,
    updateDocument,
    deleteDocument,
    deleteComment,
    comments,
  } = useGetDocument<Link>(DOCUMENTS_DB.LINKS, id);

  const handleDelete = async () => {
    try {
      await deleteDocument();

      // Log the action
      await logDelete(DOCUMENTS_DB.LINKS, id || '', data?.title);

      toast.success('Enlace eliminado correctamente', {
        theme: 'colored',
      });
      navigate('/dashboard/links');
    } catch (error) {
      console.log(error);
      toast.error('Error al eliminar el enlace', { theme: 'colored' });
    }
  };

  const handleSave = async (updateData: Link) => {
    try {
      const updatedData = { ...data, ...updateData };
      console.log(updatedData);
      await updateDocument(updatedData);

      // Log the action
      await logUpdate(DOCUMENTS_DB.LINKS, id || '', data?.title, updatedData);

      toast.success('Enlace actualizado correctamente', {
        theme: 'colored',
      });
    } catch (error) {
      console.log(error);
      toast.error('Error al actualizar el enlace', { theme: 'colored' });
    }
  };

  if (isLoading) return <div>Loading...</div>;

  if (error) return <div>Error: {error}</div>;

  if (!data) return <div>No data</div>;

  return (
    <div className="p-4 flex flex-row md:flex-col gap-8">
      <HeaderDetailDocument
        title={data.title}
        handleDelete={() => setIsAlertMessageOpen(true)}
      />

      <StatsDetailDocument data={data} />

      <FormAddDocument onSave={handleSave} document={data} contentType="link" />

      <div className="flex flex-col md:grid md:grid-cols-2 gap-4">
        <CommentsDetailDocument data={comments} deleteComment={deleteComment} />
      </div>

      <AlertMessage
        title="Eliminar Enlace"
        message="¿Estás seguro de querer eliminar este enlace?"
        onConfirm={handleDelete}
        onCancel={() => setIsAlertMessageOpen(false)}
        isOpen={isAlertMessageOpen}
      />
    </div>
  );
};

export default LinkDetailsPage;
